import React from 'react';
import { Scale, Sparkles, Users } from 'lucide-react';
import PillTabs from '../../../../components/common/PillTabs';
import { useGovernedMcp } from '../governedMcpStore';
import ClientsTab from './ClientsTab';
import PoliciesTab from './PoliciesTab';
import SetupTab from './SetupTab';

const SECTIONS = [
  { id: 'setup' as const, label: 'Setup', icon: Sparkles },
  { id: 'clients' as const, label: 'Clients', icon: Users },
  { id: 'policies' as const, label: 'Policies', icon: Scale },
];

export default function ConfigurationTab({
  isLight,
  onToast,
}: {
  isLight: boolean;
  onToast: (type: 'success' | 'error' | 'info', message: string) => void;
}) {
  const { state, setConfigSection } = useGovernedMcp();
  const section = state.configSection;

  return (
    <div className="space-y-5">
      <PillTabs
        isLight={isLight}
        ariaLabel="Configuration sections"
        value={section}
        items={SECTIONS}
        onChange={setConfigSection}
      />
      <div className="min-w-0">
        {section === 'setup' ? <SetupTab isLight={isLight} onToast={onToast} /> : null}
        {section === 'clients' ? <ClientsTab isLight={isLight} onToast={onToast} /> : null}
        {section === 'policies' ? <PoliciesTab isLight={isLight} onToast={onToast} /> : null}
      </div>
    </div>
  );
}
